import { PatientsByphoneOrderAction } from "./patients.byphone.order.types";

export const patientsByphoneOrderRequest = (order: number[]): PatientsByphoneOrderAction => ({ type: 'PATIENTS_BYPHONE_ORDER_REQUEST', params: { order } })

export const patientsByphoneOrderSuccess = (): PatientsByphoneOrderAction => ({ type: 'PATIENTS_BYPHONE_ORDER_SUCCESS' })

export const patientsByphoneOrderFailure = () => ({ type: 'PATIENTS_BYPHONE_ORDER_FAILURE' } as const)